import { NAV, STUDIO } from "@/content";
import { SITE } from "@/constants/testIds";
import { WhatsappIcon } from "./WhatsappIcon";

export const Footer = () => (
  <footer data-testid={SITE.footer} className="bg-navy-950 text-navy-100">
    <div className="container-x py-16 grid md:grid-cols-12 gap-12">
      <div className="md:col-span-4">
        <img src="/brand/logo-white.png" alt="Studio Legale D'Arienzo" className="h-24 w-auto" />
      </div>
      <div className="md:col-span-4 text-sm leading-7">
        <p className="font-semibold text-white">{STUDIO.lawyer}</p>
        <p>{STUDIO.address}</p>
        <p>{STUDIO.city}</p>
        <p className="mt-3">tel. {STUDIO.phoneLabel}</p>
        <p>mail {STUDIO.email}</p>
        <p>pec {STUDIO.pec}</p>
      </div>
      <nav className="md:col-span-4 grid grid-cols-2 gap-3 text-sm content-start">
        {NAV.map((n) => (
          <a key={n.id} href={`#${n.id}`} className="hover:text-white transition-colors">{n.label}</a>
        ))}
      </nav>
    </div>
    <div className="border-t border-white/10">
      <div className="container-x py-6 flex flex-col sm:flex-row gap-3 justify-between text-xs text-navy-200">
        <p>© {new Date().getFullYear()} {STUDIO.name} · <span data-testid={SITE.footerVat}>P.IVA [da fornire]</span></p>
        <p>Privacy Policy [da fornire] · Cookie Policy [da fornire]</p>
      </div>
    </div>
  </footer>
);

export const FloatingWhatsapp = () => (
  <a
    href={STUDIO.whatsappHref}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={SITE.floatingWhatsapp}
    aria-label="Scrivi su WhatsApp"
    className="fixed bottom-24 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-whatsapp text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] hover:bg-whatsapp-dark transition-colors"
  >
    <WhatsappIcon className="h-6 w-6" />
  </a>
);
